/* eslint-disable no-console */
import { useEffect, useState } from 'react';
import BreadCrumb from './BreadCrumbComponent';
import Urls from '../../utils/urls';

import Summary from './summary';
import Footer from './footer';
import PaymentSummary from './paymentSummary';
import BaseUrls from '../../utils/baseUrls';
import { prefixPath } from '../../utils/helpers';
import apiBackendInstance from '../../utils/axios';

interface MetaKeyValueFields {
  [key: string]: string | number;
}
interface ItemsEntity {
  name: string,
  per_unit_cost_description: {
      per_unit_cost: number,
      unit: string,
  },
  tool_tip_note:string,
  quantity: number,
  cost: number
}
interface PaymentSummaryType {
  summary: summaryType,
  items: ItemsEntity[],
  total_amount: number|string,
  redirection_links: {
      pay_now: string,
      pay_later: string,
  },
}
interface summaryType{
  service_type: string,
  reference_name:string,
  note: string,
  meta_key_value_fields: MetaKeyValueFields,
}

const PaymentBody = ({ refId }: { refId: string | number }) => {
  const [checkoutData, setCheckoutData] = useState({} as PaymentSummaryType);
  const [payNow, setPayNow] = useState('');
  const [isLoading, setLoading] = useState(true);
  const [payLater, setPayLater] = useState('');
  const theme = BaseUrls.getkey();
  const loaderUrl = window.location.origin + prefixPath(`/img/${theme}/spin.svg`);

  useEffect(() => {
    const spinnerDiv = document.getElementById('spinnerDiv');
    if (spinnerDiv) {
      spinnerDiv.style.display = 'block';
    }
    apiBackendInstance.get(Urls.getCheckoutData(refId), {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }).then((response) => {
      if (response && response.data && response.data.data) {
        setCheckoutData(response.data.data);
        setPayNow(response.data.data.redirection_links.pay_now);
        setPayLater(response.data.data.redirection_links.pay_later);
      }
      if (spinnerDiv) {
        spinnerDiv.style.display = 'none';
      }
      setLoading(false);
    }).catch((err) => {
      console.error(err);
      if (spinnerDiv) {
        spinnerDiv.style.display = 'none';
      }
      setLoading(false);
    });
  }, []);

  const breadcrumbMessage = () => 'Payment /';

  return (
        <section className="px-5 col-12 workspace mb-3">
            <div className="row mt-3">
                <BreadCrumb breadcrumbURI={breadcrumbMessage()} />
            </div>
            <div className="card mt-5 mb-5 rounded-3">
              <div className="card-body p-0">
                <section className="mt-5">
                  <div className="row mx-4 mb-5">
                  {!isLoading && <Summary data={checkoutData.summary} />}
                    {!isLoading && <PaymentSummary data={checkoutData.items} totalAmount={checkoutData.total_amount} />}
                  </div>
                </section>
              </div>
              <div
                  id="spinnerDiv"
                  className="text-center mx-5 p-3 col-11 "
                  style={{
                    position: 'absolute', display: 'none', zIndex: 10,
                  }}
              >
                  <img className="" style={{ marginTop: '25%' }} src={loaderUrl} alt="spinnner" />
              </div>
                <Footer payNowLink={payNow} payLaterLink={payLater} />
            </div>
        </section>
  );
};

export default PaymentBody;
